export default __webpack_public_path__ + "static/media/loop2.f83d9abf.png";